import React, { useContext } from "react";
import { CssBaseline, GlobalStyles, ThemeProvider } from "@mui/material";
import { CondicaoContext } from "../contexto";
import { usePreferencias } from "./PreferenciasContext";
import { obterTemaSear } from "../estilos/tema";
import { configuracaoLuminosidade } from "../config/preferencias";

// Um único provedor atende rotas, menus, diálogos e os portais do MUI.
export default function TemaProvider({ children }) {
  const { role, condicao, loading } = useContext(CondicaoContext);
  const { tema, luminosidade } = usePreferencias();
  const autenticado = !loading && condicao === false;
  const nivel = autenticado ? luminosidade : configuracaoLuminosidade.padrao;
  return <ThemeProvider theme={obterTemaSear(autenticado ? tema : "claro", autenticado ? role : undefined)}>
    <CssBaseline />
    <GlobalStyles styles={{
      // Na raiz, o ajuste inclui os portais sem criar um contêiner para o layout.
      ":root": { filter: nivel === configuracaoLuminosidade.padrao ? "none" : `brightness(${nivel / 100})` },
      "@media print": { ":root": { filter: "none" } },
    }} />
    {children}
  </ThemeProvider>;
}
